import { styled } from '@nykaa/ui-components';

import Camera from 'shared/svg/Camera';

export const FloatingImageContainer = styled.div<{ x: number; y: number }>`
  position: fixed;
  top: ${(props) => props.y}px;
  left: ${(props) => props.x}px;
  z-index: 1000;
  transform: translate(-50%, -50%);
  touch-action: none;
`;

export const ImageThumbnail = styled.div`
  width: 46px;
  height: 46px;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  position: relative;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }
`;

export const CameraIconWrapper = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  ${({ theme }) => `
    padding: ${theme.spacing.spacing50};
  
`}
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CameraIconStyled = styled(Camera)`
  width: 100%;
  height: 100%;
  filter: brightness(0) invert(1); // makes it white
`;

export const CameraIcon = styled(Camera)``;

export const OptionsContainer = styled.div`
  position: absolute;
  bottom: 70px;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${({ theme }) => theme.colors.surface};
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  padding: 10px;
  width: 200px;
  display: flex;
  flex-direction: column;
  z-index: 1001;
`;

export const OptionButton = styled.button`
  background-color: ${({ theme }) => theme.colors.surface};
  color: ${({ theme }) => theme.colors.textPrimary};
  border: none;
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid ${({ theme }) => theme.colors.surface20};

  &:last-child {
    border-bottom: none;
  }

  &:active {
    background-color: ${({ theme }) => theme.colors.surface20};
  }
`;

export const SheetContent = styled.div`
  padding: 16px;
`;

export const SheetHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.surface20};
`;

export const SheetTitle = styled.h3`
  margin: 0;
  ${({ theme }) => theme.typography.titleMedium};
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const PillContainer = styled.div`
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  animation: all 0.3s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 40px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 130px;
  z-index: 9;
  ${({ theme }) => `
    background-color: ${theme.colors.surface};
    padding:  ${theme.spacing.spacing40};
    
  `}
`;

export const PillContent = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PillText = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: 500;
`;

export const RetryButton = styled.button`
  border: none;
  cursor: pointer;
  ${({ theme }) => `
    background-color: ${theme.colors.surface};
    color:  ${theme.colors.textPrimary};
    margin-left: ${theme.spacing.spacing20};
  
`}
  ${({ theme }) => theme.typography.bodyLarge};
`;
